import { GliderFileType } from '@/enum/GliderFileType'
import { IWobGliderBaseConstParam, WobGliderBase } from '@/models/wob//WobGliderBase'
import { GliderFileImportStep } from '@/enum/GliderFileImportStep';

export interface IWobGliderFileConstParam extends IWobGliderBaseConstParam {
  gliderFileType: GliderFileType | null
  gliderFileStep: GliderFileImportStep | null
  targetYosCycles: Array<number> | null
  dataProgression: number | null
  targetMisId: number | null
  importedCsvHeaders: Array<string> | null
}

export class WobGliderFile extends WobGliderBase {
  public gliderFileType: GliderFileType | null
  public gliderFileStep: GliderFileImportStep | null  
  public targetYosCycles: Array<number> | null
  public dataProgression: number | null
  public targetMisId: number | null
  public importedCsvHeaders: Array<string> | null

  public get isRunning() {
    return  this.gliderFileStep == GliderFileImportStep.StagingRunning ||
            this.gliderFileStep == GliderFileImportStep.StagingFinished ||
            this.gliderFileStep == GliderFileImportStep.IndexingRunning /*||
            this.gliderFileStep == GliderFileImportStep.IndexingFinished ||
            this.gliderFileStep == GliderFileImportStep.CacheGraphRunning    */
  }

  public get isDownloadable() {
    return  this.gliderFileStep == GliderFileImportStep.CacheGraphFinished
    ||this.gliderFileStep == GliderFileImportStep.IndexingFinished
    || this.gliderFileStep == GliderFileImportStep.CacheGraphRunning    
  }

  constructor({ gliderFileType,gliderFileStep, targetYosCycles, dataProgression,targetMisId,importedCsvHeaders, ...args }: IWobGliderFileConstParam) {
    super(args)
    this.gliderFileType = gliderFileType
    this.gliderFileStep = gliderFileStep    
    this.targetYosCycles = targetYosCycles
    this.dataProgression = dataProgression
    this.targetMisId = targetMisId
    this.importedCsvHeaders = importedCsvHeaders
  }
}
